import { baseThemeValues } from 'constants/common';

export const gistViewTheme = {
  bg: 'palette.surface.1',
  block: {
    bg: 'palette.surface.2',
    borderRadius: '12px',
    subBlock: {
      bg: 'palette.surface.3',
      borderRadius: '8px',
    },
    title: 'palette.tertiary.90',
  },
  highlightedText: 'palette.primary.20',
  modal: {
    highlightedText: 'palette.primary.40',
    message: 'palette.tertiary.95',
  },
  redirectLink: {
    fontFamily: baseThemeValues.inherit,
    fontSize: '20px',
    fontWeight: 500,
  },
  title: 'palette.tertiary.90',
};

export const gridViewTheme = {
  deleteIcon: 'palette.error.70',
  title: 'palette.tertiary.95',
};
